module.exports = __webpack_public_path__ + "static/footer-bg-dd787ebd4aad55581961fdfa7f924101.png";